import { IconLoading01 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import * as S from './style';

const LoadingIcon = () => (
  <S.LoadingIcon className="loading-icon">
    <IconLoading01 />
  </S.LoadingIcon>
);

export default LoadingIcon;
